


export const ADMIN_COMIC_LIST_REQUEST = "ADMIN_COMIC_LIST_REQUEST";
export const ADMIN_COMIC_LIST_SUCCESS = "ADMIN_COMIC_LIST_SUCCESS";
export const ADMIN_COMIC_LIST_FAIL = "ADMIN_COMIC_LIST_FAIL";


export const ADMIN_COMIC_UPDATE_STATUS_REQUEST = "ADMIN_COMIC_UPDATE_STATUS_REQUEST";
export const ADMIN_COMIC_UPDATE_STATUS_SUCCESS = "ADMIN_COMIC_UPDATE_STATUS_SUCCESS";
export const ADMIN_COMIC_UPDATE_STATUS_FAIL = "ADMIN_COMIC_UPDATE_STATUS_FAIL";

export const SET_COMIC_STATUS_REQUEST = "SET_COMIC_STATUS_REQUEST";
export const SET_COMIC_STATUS_SUCCESS = "SET_COMIC_STATUS_SUCCESS";
export const SET_COMIC_STATUS_FAIL = "SET_COMIC_STATUS_FAIL";
